import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'xqnr-blog-posts',
    templateUrl: './blog-posts.component.pug',
    styleUrls: ['./blog-posts.component.scss'],
    standalone: false
})
export class BlogPostsComponent implements OnInit {
  @Input() posts: any[];

  constructor() {}

  ngOnInit() {}
}
